import { Box, Divider, Typography } from '@mui/material'
import { memo } from 'react'

const SoalOnly = memo(({ dataQuestion }) => {
  return (
    <Box display="flex" flexDirection="column" height="100%" mx="-1rem">
      <Box
        bgcolor="#9AA5EA"
        width="100%"
        sx={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <Divider
          sx={{
            backgroundColor: 'white',
            height: '3px',
          }}
        />

        <Box display="flex" justifyContent="center" alignItems="center" py={3}>
          {/* <img
            src={dataQuestion?.gambar}
            alt="img-soal"
            style={{ maxWidth: '100%', height: 'auto' }}
          /> */}
          <Typography
            textAlign={'justify'}
            fontWeight={500}
            fontSize={'14px'}
            color={'white'}
            letterSpacing={1.2}
            lineHeight={1.7}
            sx={{
              textAlign: 'center',
              whiteSpace: 'pre-wrap',
            }}
          >
            {dataQuestion?.desc}
          </Typography>
        </Box>
      </Box>
      <Box height="100%" pt={5} px={1} mb={2}>
        {Object.keys(dataQuestion || {})
          .filter((key) => key.startsWith('soal_'))
          .map((key, _idx) => (
            <Typography
              textAlign="left"
              fontWeight={500}
              fontSize="14px"
              letterSpacing={1.2}
              lineHeight={1.7}
              marginBottom={2}
              sx={{
                textAlign: 'left',
                whiteSpace: 'pre-wrap',
              }}
            >
              {dataQuestion[key]}
            </Typography>
          ))}
      </Box>
    </Box>
  )
}, arePropEqual)

function arePropEqual(oldProps, newProps) {
  return oldProps.indices !== newProps.indices
}
export default SoalOnly
